import axios from 'axios';
import { IData } from '../interfaces';
import { locationQuery } from '../utils';

export async function getVoucher (values: IData) {
  const {data} = await axios.post('https://api.n2app.info/voucher/invitation-voucher', {
    partnerId: 126,
    firstName: values?.firstName,
    lastName: values?.lastName,
    email: values?.email,
    phone: values?.phone?.replace(/\D/g, ""),
    utmSource: locationQuery().get('utm_source'),
    tid: locationQuery().get('tid')
  },{
    headers: {
      'Authorization': `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNzI0MTk1MTg0LCJqdGkiOiI4ZjM2MDVkNGVlZGQ0Mzk5YmY0NTMwOTZkNTQwM2U2NSIsInVzZXJfaWQiOjcyNTJ9.87GiL02Q-wSZD9WQ1ruMy2vSiqtkK5-aeKSLK4aEeL4`,
      'Content-Type': 'application/json',
    },
  });

  return data;
}

export async function sendData (values: IData) {
  try {
    await axios.post("https://n2-dona-de-mim-api.n2app.info/register", values);
    return true; 
  } catch (error) {
    console.log('error sendData');
    return false;
  }
}